import { SocialLoginProvider } from '@app/modules/auth/provider/auth/auth.structs';

export enum RapidLoginType {
    OWN = "own",
    O_AUTH = "oAuth",
    BROKER = "broker"
}

export const RapidLoginSource = {
    LOCAL: "local",
    GOOGLE: SocialLoginProvider.GOOGLE,
    Facebook: SocialLoginProvider.FACEBOOK
}

export enum AdminTabType {
    USER_MANAGEMENT = 'USER_MANAGEMENT',
    DEPLOYED_SECTION = 'DEPLOYED_SECTION'
}

export enum AccountState {
    Active = "A",
    Locked = "L",
    FirstTime = "N",
    Inactive = "I",
}
